import { Capacitor } from "@capacitor/core";

// Lot 554 (WhatsApp) : conversation lue dans l'app → la notification empilée de ce fil quitte la barre du téléphone
// (Android : tag = « chat:<conv> » ; iOS : userInfo.thread) et le navigateur (service worker, tag identique).
export const chatThread = (convId) => `chat:${convId}`;

export async function clearDeliveredChatNotifications(convId) {
  if (!convId) return;
  const thread = chatThread(convId);
  if (Capacitor.isNativePlatform()) {
    try {
      const { PushNotifications } = await import("@capacitor/push-notifications");
      const { notifications = [] } = await PushNotifications.getDeliveredNotifications();
      const mine = notifications.filter((n) => n.tag === thread || n.data?.thread === thread);
      if (mine.length) await PushNotifications.removeDeliveredNotifications({ notifications: mine });
    } catch { /* noop */ }
    return;
  }
  try {
    if (!("serviceWorker" in navigator)) return;
    const reg = await navigator.serviceWorker.ready;
    const list = await reg.getNotifications({ tag: thread });
    list.forEach((n) => { try { n.close(); } catch { /* noop */ } });
  } catch { /* noop */ }
}
